// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Labels = require("../../reason/clients/components/Labels.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let UTCDate = require("../../reason/common/types/UTCDate.bs.js");
let DateFns = require("date-fns");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let OwnBuyerNeedStatusLabel_buyerNeedV5_graphql = require("../../__generated__/OwnBuyerNeedStatusLabel_buyerNeedV5_graphql.bs.js");

let convertFragment = OwnBuyerNeedStatusLabel_buyerNeedV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, OwnBuyerNeedStatusLabel_buyerNeedV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(OwnBuyerNeedStatusLabel_buyerNeedV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, OwnBuyerNeedStatusLabel_buyerNeedV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(OwnBuyerNeedStatusLabel_buyerNeedV5_graphql.node, convertFragment, fRef);
}

let BuyerNeedFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function OwnBuyerNeedStatusLabel$WithoutErrorBoundary(props) {
  let match = RescriptRelay_Fragment.useFragment(OwnBuyerNeedStatusLabel_buyerNeedV5_graphql.node, convertFragment, props.buyerNeed);
  let status = match.status;
  switch (status.__typename) {
    case "ActiveBuyerNeed" :
      if (!status.isRenewable) {
        return JsxRuntime.jsx(Labels.ActiveStatusLabel.make, {});
      }
      let daysLeft = DateFns.differenceInCalendarDays(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(status.activeUntil)), new Date());
      return JsxRuntime.jsx(Labels.ExpiringStatusLabel.make, {
        expiringIn: Labels.stringOfExpiring(daysLeft)
      });
    case "ExpiredBuyerNeed" :
      return JsxRuntime.jsx(Labels.ExpiredStatusLabel.make, {});
    case "InContractBuyerNeed" :
      return JsxRuntime.jsx(Labels.InContractLabel.make, {});
    case "PurchasedBuyerNeed" :
      return JsxRuntime.jsx(Labels.PurchasedLabel.make, {});
    case "WithdrawnBuyerNeed" :
      return JsxRuntime.jsx(Labels.WithdrawnLabel.make, {});
    case "__unselected" :
      return null;
  }
}

let WithoutErrorBoundary = {
  make: OwnBuyerNeedStatusLabel$WithoutErrorBoundary
};

function OwnBuyerNeedStatusLabel(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "buyerNeed status",
    children: JsxRuntime.jsx(OwnBuyerNeedStatusLabel$WithoutErrorBoundary, {
      buyerNeed: props.buyerNeed
    })
  });
}

let make = OwnBuyerNeedStatusLabel;

exports.BuyerNeedFragment = BuyerNeedFragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Labels Not a pure module */
